export default __webpack_public_path__ + "static/media/exclamation-red.34bf55b1.svg";